import { displayElem } from '../functions/displayElem';
import { updateText } from '../functions/updateText';

export const handleFallback = next => async ({ directive, meta, error, tries, resolved }) => {

  if (!resolved) {
    updateText('#feedback', error.message);
    displayElem('#loadingOverlay', 'none');
    displayElem('#passwordForm', 'inline-block');
    resolved = true;
  }

  return next({ directive, meta, error, tries, resolved });
};
